import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 開発環境でのみコンソールをクリーンアップ
if (process.env.NODE_ENV === 'development') {
  // ブラウザ拡張機能のログを非表示にする
  // eslint-disable-next-line no-console
  const originalConsoleLog = console.log;
  // const originalConsoleWarn = console.warn;
  // const originalConsoleError = console.error;

  // eslint-disable-next-line no-console
  console.log = (...args) => {
    const message = args.join(' ');
    if (
      !message.includes('content.js') &&
      !message.includes('web-client-content-script.js') &&
      !message.includes('Env: production') &&
      !message.includes('initContentScriptOnPageLoad') &&
      !message.includes('onMount: writer modal')
    ) {
      originalConsoleLog.apply(console, args);
    }
  };

  // console.warn = (...args) => {
  // const message = args.join(' ');
  // if (
  //   !message.includes('content.js') &&
  //   !message.includes('web-client-content-script.js') &&
  //   !message.includes('Unchecked runtime.lastError') &&
  //   !message.includes('A listener indicated an asynchronous response')
  // ) {
  //   // originalConsoleWarn.apply(console, args);
  // }
  // };

  // console.error = (...args) => {
  // const message = args.join(' ');
  // if (
  //   !message.includes('content.js') &&
  //   !message.includes('web-client-content-script.js') &&
  //   !message.includes('Unchecked runtime.lastError') &&
  //   !message.includes('A listener indicated an asynchronous response')
  // ) {
  //   // originalConsoleError.apply(console, args);
  // }
  // };
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// eslint-disable-next-line no-console
reportWebVitals();
